/**
 * 数据大屏 Mock 接口服务
 * 包含所有板块的数据接口
 */

// 基础接口 - 获取集团门店列表（用于获取appid）
export const getGroupStoreList = () => {
  return Promise.resolve({
    code: 0,
    data: [
      { appid: 'wx0e060adcd6f1e2a3', storeName: '万象' },
      { appid: 'wx1f1e0c0f2b2d3e4f', storeName: '俪丰' },
      { appid: 'wx2g2f1d1e2c3f4g5h', storeName: '联农' },
    ],
    message: 'success',
  })
}

// 左侧板块 - 1. 顶部统计卡片
export const getStatsCards = () => {
  return Promise.resolve({
    code: 0,
    data: {
      productCount: 126, // 商品数量
      schoolCount: 49636, // 学校数量
      orderCount: 15836, // 采购订单
    },
    message: 'success',
  })
}

// 左侧板块 - 2. 月采购订单量统计（折线图）
export const getOrderLineChart = (params = {}) => {
  const { appid = '' } = params
  // 根据appid判断类型，包含'lifeng'或特定appid为俪丰，其他为联农
  const isLifeng = appid.includes('lifeng') || appid === 'wx1f1e0c0f2b2d3e4f' || !appid
  return Promise.resolve({
    code: 0,
    data: {
      xAxis: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
      series: isLifeng
        ? [1200, 1350, 1480, 1620, 1750, 1880, 1920, 1850, 1780, 1950, 2100, 2250]
        : [980, 1120, 1250, 1380, 1520, 1650, 1720, 1680, 1590, 1750, 1880, 2010],
    },
    message: 'success',
  })
}

// 左侧板块 - 3. 月采购金额统计（折线图）
export const getAmountLineChart = (params = {}) => {
  const { appid = '' } = params
  // 根据appid判断类型，包含'lifeng'或特定appid为俪丰，其他为联农
  const isLifeng = appid.includes('lifeng') || appid === 'wx1f1e0c0f2b2d3e4f' || !appid
  return Promise.resolve({
    code: 0,
    data: {
      xAxis: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
      series: isLifeng
        ? [2850, 3120, 3580, 3960, 4250, 4680, 4520, 4380, 4650, 4820, 4950, 5200]
        : [2536, 2780, 3150, 3520, 3850, 4120, 3980, 3850, 4080, 4250, 4380, 4520],
    },
    message: 'success',
  })
}

// 左侧板块 - 4. 产品类型销量统计（饼图）
export const getSaleTypePie = (params = {}) => {
  const { appid = '' } = params
  // 根据appid判断类型，包含'lifeng'或特定appid为俪丰，其他为联农
  const isLifeng = appid.includes('lifeng') || appid === 'wx1f1e0c0f2b2d3e4f' || !appid
  const data = isLifeng
    ? [
        { value: 35, name: '蔬菜水果' },
        { value: 25, name: '肉蛋家禽' },
        { value: 20, name: '米面粮油' },
        { value: 12, name: '鱼虾水产' },
        { value: 8, name: '其他' },
      ]
    : [
        { value: 32, name: '蔬菜水果' },
        { value: 28, name: '肉蛋家禽' },
        { value: 18, name: '米面粮油' },
        { value: 15, name: '鱼虾水产' },
        { value: 7, name: '其他' },
      ]
  return Promise.resolve({
    code: 0,
    data,
    message: 'success',
  })
}

// 左侧板块 - 5. 产品类型销售额统计（柱状图）
export const getSaleTypeBar = (params = {}) => {
  const { appid = '' } = params
  // 根据appid判断类型，包含'lifeng'或特定appid为俪丰，其他为联农
  const isLifeng = appid.includes('lifeng') || appid === 'wx1f1e0c0f2b2d3e4f' || !appid
  return Promise.resolve({
    code: 0,
    data: {
      categories: [
        '蔬菜水果',
        '肉蛋家禽',
        '米面粮油',
        '鱼虾水产',
        '豆制品类',
        '菌菇干货',
        '茶叶醇香',
        '地方特色',
      ],
      series: isLifeng
        ? [2850, 2536, 2236, 1985, 1650, 1420, 1250, 980]
        : [2650, 2380, 2150, 1820, 1580, 1350, 1180, 920],
    },
    message: 'success',
  })
}

// 左侧板块 - 6. 商品销量排行
export const getProductSalesRank = (params = {}) => {
  const { appid = '' } = params
  // 根据appid判断类型，包含'lifeng'或特定appid为俪丰，其他为联农
  const isLifeng = appid.includes('lifeng') || appid === 'wx1f1e0c0f2b2d3e4f' || !appid
  const data = isLifeng
    ? [
        { name: '商品名称商品名称商品名称商品名称', value: 45201 },
        { name: '商品名称商品名称商品名称商品名称', value: 43850 },
        { name: '商品名称商品名称商品名称商品名称', value: 42100 },
        { name: '商品名称商品名称商品名称商品名称', value: 39850 },
        { name: '商品名称商品名称商品名称商品名称', value: 38200 },
        { name: '商品名称商品名称商品名称商品名称', value: 36500 },
        { name: '商品名称商品名称商品名称商品名称', value: 34800 },
        { name: '商品名称商品名称商品名称商品名称', value: 33200 },
        { name: '商品名称商品名称商品名称商品名称', value: 31800 },
        { name: '商品名称商品名称商品名称商品名称', value: 30500 },
      ]
    : [
        { name: '商品名称商品名称商品名称商品名称', value: 38500 },
        { name: '商品名称商品名称商品名称商品名称', value: 37200 },
        { name: '商品名称商品名称商品名称商品名称', value: 35800 },
        { name: '商品名称商品名称商品名称商品名称', value: 34200 },
        { name: '商品名称商品名称商品名称商品名称', value: 32800 },
        { name: '商品名称商品名称商品名称商品名称', value: 31500 },
        { name: '商品名称商品名称商品名称商品名称', value: 30200 },
        { name: '商品名称商品名称商品名称商品名称', value: 28800 },
        { name: '商品名称商品名称商品名称商品名称', value: 27500 },
        { name: '商品名称商品名称商品名称商品名称', value: 26200 },
      ]
  return Promise.resolve({
    code: 0,
    data,
    message: 'success',
  })
}

// 左侧板块 - 7. 商品销售额排行
export const getProductAmountRank = (params = {}) => {
  const { appid = '' } = params
  // 根据appid判断类型，包含'lifeng'或特定appid为俪丰，其他为联农
  const isLifeng = appid.includes('lifeng') || appid === 'wx1f1e0c0f2b2d3e4f' || !appid
  const data = isLifeng
    ? [
        { name: '商品名称商品名称商品名称商品名称', value: 353.6 },
        { name: '商品名称商品名称商品名称商品名称', value: 342.8 },
        { name: '商品名称商品名称商品名称商品名称', value: 328.5 },
        { name: '商品名称商品名称商品名称商品名称', value: 315.2 },
        { name: '商品名称商品名称商品名称商品名称', value: 298.6 },
        { name: '商品名称商品名称商品名称商品名称', value: 285.3 },
        { name: '商品名称商品名称商品名称商品名称', value: 272.1 },
        { name: '商品名称商品名称商品名称商品名称', value: 258.9 },
        { name: '商品名称商品名称商品名称商品名称', value: 245.7 },
        { name: '商品名称商品名称商品名称商品名称', value: 232.4 },
      ]
    : [
        { name: '商品名称商品名称商品名称商品名称', value: 298.5 },
        { name: '商品名称商品名称商品名称商品名称', value: 285.2 },
        { name: '商品名称商品名称商品名称商品名称', value: 272.8 },
        { name: '商品名称商品名称商品名称商品名称', value: 258.6 },
        { name: '商品名称商品名称商品名称商品名称', value: 245.3 },
        { name: '商品名称商品名称商品名称商品名称', value: 232.1 },
        { name: '商品名称商品名称商品名称商品名称', value: 218.9 },
        { name: '商品名称商品名称商品名称商品名称', value: 205.7 },
        { name: '商品名称商品名称商品名称商品名称', value: 192.4 },
        { name: '商品名称商品名称商品名称商品名称', value: 179.2 },
      ]
  return Promise.resolve({
    code: 0,
    data,
    message: 'success',
  })
}

// 中间板块 - 1. 实时累积交易金额（Flop）
export const getPlatformTotal = () => {
  return Promise.resolve({
    code: 0,
    data: {
      platformSaleTotal: 26247437, // 实时累积交易金额（整数）
      totalSalesAmount: 5236.25, // 万象销售金额（万元）
      ruralEconomyAmount: 3820.52, // 俪丰销售金额（万元）
      ckPutTotalPriceTotal: 1412.33, // 联农销售金额（万元）
    },
    message: 'success',
  })
}

// 中间板块 - 2. 地图数据
export const getMapData = () => {
  return Promise.resolve({
    code: 0,
    data: [
      { districtCode: 'wd', districtName: '吴店镇', amount: 2850, value: 2850 },
      { districtCode: 'hd', districtName: '郝店镇', amount: 2350, value: 2350 },
      { districtCode: 'yd', districtName: '杨寨镇', amount: 1980, value: 1980 },
      { districtCode: 'gm', districtName: '广水街道', amount: 1650, value: 1650 },
      { districtCode: 'mp', districtName: '马坪镇', amount: 1420, value: 1420 },
      { districtCode: 'cl', districtName: '长岭镇', amount: 1280, value: 1280 },
      { districtCode: 'cj', districtName: '陈巷镇', amount: 1150, value: 1150 },
      { districtCode: 'ld', districtName: '骆店镇', amount: 980, value: 980 },
      { districtCode: 'cx', districtName: '城郊街道', amount: 850, value: 850 },
      { districtCode: 'ch', districtName: '蔡河镇', amount: 720, value: 720 },
      { districtCode: 'ys', districtName: '应山街道', amount: 650, value: 650 },
      { districtCode: 'sl', districtName: '十里街道', amount: 580, value: 580 },
      { districtCode: 'lid', districtName: '李店镇', amount: 520, value: 520 },
      { districtCode: 'tp', districtName: '太平镇', amount: 480, value: 480 },
      { districtCode: 'gs', districtName: '关庙镇', amount: 420, value: 420 },
      { districtCode: 'wsg', districtName: '武胜关镇', amount: 380, value: 380 },
      { districtCode: 'yz', districtName: '余店镇', amount: 320, value: 320 },
      { districtCode: 'kfq', districtName: '开发区', amount: 280, value: 280 },
    ],
    message: 'success',
  })
}

// 中间板块 - 3. 地图表格数据（MapTable）
export const getMapTableData = (params = {}) => {
  const { districtName = '吴店镇', timeRange = 'all' } = params

  // 根据地区名称生成不同的基础数据
  const districtDataMap = {
    吴店镇: { baseSchoolCount: 48, baseOrderCount: 2316, baseAmount: 223.18 },
    郝店镇: { baseSchoolCount: 35, baseOrderCount: 1856, baseAmount: 186.52 },
    杨寨镇: { baseSchoolCount: 28, baseOrderCount: 1423, baseAmount: 142.36 },
    广水街道: { baseSchoolCount: 42, baseOrderCount: 2156, baseAmount: 215.68 },
    马坪镇: { baseSchoolCount: 22, baseOrderCount: 1123, baseAmount: 112.45 },
    长岭镇: { baseSchoolCount: 32, baseOrderCount: 1623, baseAmount: 162.58 },
    陈巷镇: { baseSchoolCount: 25, baseOrderCount: 1289, baseAmount: 128.92 },
    骆店镇: { baseSchoolCount: 18, baseOrderCount: 956, baseAmount: 95.68 },
    城郊街道: { baseSchoolCount: 38, baseOrderCount: 1923, baseAmount: 192.36 },
    蔡河镇: { baseSchoolCount: 20, baseOrderCount: 1023, baseAmount: 102.58 },
    应山街道: { baseSchoolCount: 45, baseOrderCount: 2345, baseAmount: 234.56 },
    十里街道: { baseSchoolCount: 30, baseOrderCount: 1523, baseAmount: 152.36 },
    李店镇: { baseSchoolCount: 15, baseOrderCount: 823, baseAmount: 82.36 },
    太平镇: { baseSchoolCount: 12, baseOrderCount: 678, baseAmount: 67.89 },
    关庙镇: { baseSchoolCount: 16, baseOrderCount: 856, baseAmount: 85.68 },
    武胜关镇: { baseSchoolCount: 14, baseOrderCount: 756, baseAmount: 75.68 },
    余店镇: { baseSchoolCount: 10, baseOrderCount: 567, baseAmount: 56.78 },
    开发区: { baseSchoolCount: 8, baseOrderCount: 423, baseAmount: 42.36 },
  }

  const baseData = districtDataMap[districtName] || districtDataMap['吴店镇']

  // 时间范围系数
  const timeRatioMap = {
    all: 1,
    year: 0.85,
    halfYear: 0.65,
    month: 0.25,
  }
  const ratio = timeRatioMap[timeRange] || 1

  // 计算当前时间范围的数据
  const schoolCount = Math.round(baseData.baseSchoolCount * ratio)
  const orderCount = Math.round(baseData.baseOrderCount * ratio)
  const purchaseAmount = (baseData.baseAmount * ratio).toFixed(2)
  const unionProfit = (baseData.baseAmount * ratio * 0.015).toFixed(2)
  const wanxiangProfit = (baseData.baseAmount * ratio * 0.009).toFixed(2)

  // 根据地区名称生成学校列表
  const generateSchoolList = district => {
    const schools = []
    const schoolCount = Math.min(
      8,
      Math.max(4, Math.round(baseData.baseSchoolCount * ratio * 0.15)),
    )
    for (let i = 1; i <= schoolCount; i++) {
      schools.push({
        id: i,
        schoolName: `${district}第${i}小学`,
        purchaseAmount: (Math.random() * 50 + 20).toFixed(1),
      })
    }
    return schools
  }

  return Promise.resolve({
    code: 0,
    data: {
      districtName,
      schoolCount,
      orderCount,
      purchaseAmount,
      unionProfit,
      wanxiangProfit,
      schoolList: generateSchoolList(districtName),
    },
    message: 'success',
  })
}

// 右侧板块 - 1. 学校采购排行
export const getSchoolPurchaseRank = (params = {}) => {
  const { timeRange = 'all' } = params
  const pieDataTemplate = [
    [
      { value: 45.75, name: '冻货、加工食材' },
      { value: 16.43, name: '肉类' },
      { value: 13.33, name: '米面类' },
      { value: 12.01, name: '食用油' },
      { value: 9.44, name: '干货调料' },
      { value: 3.13, name: '蛋类' },
      { value: 0.39, name: '水产类' },
    ],
    [
      { value: 29.27, name: '肉类' },
      { value: 18.38, name: '米面类' },
      { value: 15.76, name: '食用油' },
      { value: 11.39, name: '冻货、加工食材' },
      { value: 11.27, name: '干货调料' },
      { value: 5.69, name: '水产类' },
      { value: 5.23, name: '蛋类' },
    ],
    [
      { value: 35.5, name: '肉类' },
      { value: 22.3, name: '米面类' },
      { value: 18.6, name: '蔬菜水果' },
      { value: 12.8, name: '食用油' },
      { value: 8.5, name: '干货调料' },
      { value: 5.2, name: '蛋类' },
      { value: 3.1, name: '水产类' },
    ],
    [
      { value: 28.9, name: '冻货、加工食材' },
      { value: 25.6, name: '肉类' },
      { value: 16.8, name: '米面类' },
      { value: 14.2, name: '食用油' },
      { value: 10.5, name: '干货调料' },
      { value: 4.8, name: '蛋类' },
      { value: 2.2, name: '水产类' },
    ],
    [
      { value: 32.1, name: '肉类' },
      { value: 20.5, name: '米面类' },
      { value: 17.8, name: '蔬菜水果' },
      { value: 13.6, name: '食用油' },
      { value: 9.2, name: '干货调料' },
      { value: 4.5, name: '蛋类' },
      { value: 2.9, name: '水产类' },
    ],
  ]
  const dataMap = {
    all: [
      { name: '广水市职业技术教育中心', value: 100.48, pieData: pieDataTemplate[0] },
      { name: '广水市永阳学校', value: 97.0, pieData: pieDataTemplate[1] },
      { name: '广水市第一中学', value: 88.5, pieData: pieDataTemplate[2] },
      { name: '广水市实验中学', value: 82.3, pieData: pieDataTemplate[3] },
      { name: '广水市实验小学', value: 75.6, pieData: pieDataTemplate[4] },
      { name: '广水市第二小学', value: 68.9, pieData: pieDataTemplate[0] },
      { name: '广水市第三中学', value: 62.4, pieData: pieDataTemplate[1] },
      { name: '广水市第四小学', value: 55.8, pieData: pieDataTemplate[2] },
      { name: '广水市第五中学', value: 48.5, pieData: pieDataTemplate[3] },
      { name: '广水市第六小学', value: 42.3, pieData: pieDataTemplate[4] },
    ],
    year: [
      { name: '广水市职业技术教育中心', value: 85.2, pieData: pieDataTemplate[0] },
      { name: '广水市永阳学校', value: 78.5, pieData: pieDataTemplate[1] },
      { name: '广水市第一中学', value: 72.3, pieData: pieDataTemplate[2] },
      { name: '广水市实验中学', value: 65.8, pieData: pieDataTemplate[3] },
      { name: '广水市实验小学', value: 58.6, pieData: pieDataTemplate[4] },
      { name: '广水市第二小学', value: 52.4, pieData: pieDataTemplate[0] },
      { name: '广水市第三中学', value: 46.8, pieData: pieDataTemplate[1] },
      { name: '广水市第四小学', value: 40.5, pieData: pieDataTemplate[2] },
      { name: '广水市第五中学', value: 35.2, pieData: pieDataTemplate[3] },
      { name: '广水市第六小学', value: 30.8, pieData: pieDataTemplate[4] },
    ],
    halfYear: [
      { name: '广水市职业技术教育中心', value: 52.8, pieData: pieDataTemplate[0] },
      { name: '广水市永阳学校', value: 48.5, pieData: pieDataTemplate[1] },
      { name: '广水市第一中学', value: 42.6, pieData: pieDataTemplate[2] },
      { name: '广水市实验中学', value: 38.2, pieData: pieDataTemplate[3] },
      { name: '广水市实验小学', value: 32.5, pieData: pieDataTemplate[4] },
      { name: '广水市第二小学', value: 28.6, pieData: pieDataTemplate[0] },
      { name: '广水市第三中学', value: 24.8, pieData: pieDataTemplate[1] },
      { name: '广水市第四小学', value: 20.5, pieData: pieDataTemplate[2] },
      { name: '广水市第五中学', value: 16.8, pieData: pieDataTemplate[3] },
      { name: '广水市第六小学', value: 12.5, pieData: pieDataTemplate[4] },
    ],
    month: [
      { name: '广水市职业技术教育中心', value: 18.5, pieData: pieDataTemplate[0] },
      { name: '广水市永阳学校', value: 15.8, pieData: pieDataTemplate[1] },
      { name: '广水市第一中学', value: 12.6, pieData: pieDataTemplate[2] },
      { name: '广水市实验中学', value: 10.2, pieData: pieDataTemplate[3] },
      { name: '广水市实验小学', value: 8.5, pieData: pieDataTemplate[4] },
      { name: '广水市第二小学', value: 6.8, pieData: pieDataTemplate[0] },
      { name: '广水市第三中学', value: 5.2, pieData: pieDataTemplate[1] },
      { name: '广水市第四小学', value: 4.5, pieData: pieDataTemplate[2] },
      { name: '广水市第五中学', value: 3.2, pieData: pieDataTemplate[3] },
      { name: '广水市第六小学', value: 2.5, pieData: pieDataTemplate[4] },
    ],
  }
  return Promise.resolve({
    code: 0,
    data: {
      list: dataMap[timeRange],
    },
    message: 'success',
  })
}

// 右侧板块 - 2. 万象/联合体月度统计
export const getWanxiangMonthlyStats = () => {
  return Promise.resolve({
    code: 0,
    data: {
      months: [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ],
      salesAmount: [2850, 3120, 3580, 3960, 4250, 4680, 4520, 4380, 4650, 4820, 4950, 5200],
      grossProfit: [380, 420, 485, 540, 580, 645, 620, 595, 635, 660, 680, 720],
      lhtSalesAmount: [1850, 2120, 2580, 2960, 3250, 3680, 3520, 3380, 3650, 3820, 3950, 4200],
      lhtGrossProfit: [280, 320, 385, 440, 480, 545, 520, 495, 535, 560, 580, 620],
    },
    message: 'success',
  })
}

// 右侧板块 - 3. 供应商销售排行
export const getSupplierSalesRank = (params = {}) => {
  const { timeRange = 'all' } = params
  const supplierPieDataTemplate = [
    [
      { value: 42.5, name: '冻货、加工食材' },
      { value: 28.3, name: '肉类' },
      { value: 18.6, name: '米面类' },
      { value: 12.8, name: '食用油' },
      { value: 8.5, name: '干货调料' },
      { value: 5.2, name: '蛋类' },
      { value: 3.1, name: '水产类' },
    ],
    [
      { value: 38.2, name: '肉类' },
      { value: 25.6, name: '米面类' },
      { value: 16.8, name: '蔬菜水果' },
      { value: 12.5, name: '食用油' },
      { value: 9.8, name: '干货调料' },
      { value: 4.5, name: '蛋类' },
      { value: 2.6, name: '水产类' },
    ],
    [
      { value: 35.8, name: '冻货、加工食材' },
      { value: 22.4, name: '肉类' },
      { value: 19.5, name: '米面类' },
      { value: 11.2, name: '食用油' },
      { value: 7.8, name: '干货调料' },
      { value: 5.6, name: '蛋类' },
      { value: 2.7, name: '水产类' },
    ],
    [
      { value: 30.5, name: '肉类' },
      { value: 24.8, name: '米面类' },
      { value: 18.2, name: '蔬菜水果' },
      { value: 14.6, name: '食用油' },
      { value: 8.2, name: '干货调料' },
      { value: 3.8, name: '蛋类' },
      { value: 2.9, name: '水产类' },
    ],
    [
      { value: 33.6, name: '冻货、加工食材' },
      { value: 26.5, name: '肉类' },
      { value: 15.8, name: '米面类' },
      { value: 12.2, name: '食用油' },
      { value: 9.5, name: '干货调料' },
      { value: 4.8, name: '蛋类' },
      { value: 2.6, name: '水产类' },
    ],
  ]
  const dataMap = {
    all: [
      { name: '广水市鑫源农产品有限公司', value: 153.6, pieData: supplierPieDataTemplate[0] },
      { name: '广水市绿色田园农业合作社', value: 142.8, pieData: supplierPieDataTemplate[1] },
      { name: '广水市永丰粮油批发部', value: 128.5, pieData: supplierPieDataTemplate[2] },
      { name: '广水市鲜达肉类经营部', value: 115.2, pieData: supplierPieDataTemplate[3] },
      { name: '广水市惠民蔬菜配送中心', value: 98.6, pieData: supplierPieDataTemplate[4] },
      { name: '广水市诚信干货调料商行', value: 85.3, pieData: supplierPieDataTemplate[0] },
      { name: '广水市宏达水产批发部', value: 72.1, pieData: supplierPieDataTemplate[1] },
      { name: '广水市金源食用油经销部', value: 58.9, pieData: supplierPieDataTemplate[2] },
      { name: '广水市顺发蛋类批发中心', value: 45.7, pieData: supplierPieDataTemplate[3] },
      { name: '广水市优质冻品供应商', value: 32.4, pieData: supplierPieDataTemplate[4] },
      { name: '广水市农丰食材配送公司', value: 28.6, pieData: supplierPieDataTemplate[0] },
      { name: '广水市盛源农产品经营部', value: 25.8, pieData: supplierPieDataTemplate[1] },
      { name: '广水市兴旺粮油供应站', value: 22.5, pieData: supplierPieDataTemplate[2] },
      { name: '广水市新鲜蔬菜批发商行', value: 18.3, pieData: supplierPieDataTemplate[3] },
      { name: '广水市放心肉类配送点', value: 15.7, pieData: supplierPieDataTemplate[4] },
    ],
    year: [
      { name: '广水市鑫源农产品有限公司', value: 125.6, pieData: supplierPieDataTemplate[0] },
      { name: '广水市绿色田园农业合作社', value: 112.8, pieData: supplierPieDataTemplate[1] },
      { name: '广水市永丰粮油批发部', value: 98.5, pieData: supplierPieDataTemplate[2] },
      { name: '广水市鲜达肉类经营部', value: 85.2, pieData: supplierPieDataTemplate[3] },
      { name: '广水市惠民蔬菜配送中心', value: 72.6, pieData: supplierPieDataTemplate[4] },
      { name: '广水市诚信干货调料商行', value: 65.3, pieData: supplierPieDataTemplate[0] },
      { name: '广水市宏达水产批发部', value: 52.1, pieData: supplierPieDataTemplate[1] },
      { name: '广水市金源食用油经销部', value: 48.9, pieData: supplierPieDataTemplate[2] },
      { name: '广水市顺发蛋类批发中心', value: 35.7, pieData: supplierPieDataTemplate[3] },
      { name: '广水市优质冻品供应商', value: 22.4, pieData: supplierPieDataTemplate[4] },
    ],
    halfYear: [
      { name: '广水市鑫源农产品有限公司', value: 68.6, pieData: supplierPieDataTemplate[0] },
      { name: '广水市绿色田园农业合作社', value: 62.8, pieData: supplierPieDataTemplate[1] },
      { name: '广水市永丰粮油批发部', value: 55.5, pieData: supplierPieDataTemplate[2] },
      { name: '广水市鲜达肉类经营部', value: 48.2, pieData: supplierPieDataTemplate[3] },
      { name: '广水市惠民蔬菜配送中心', value: 42.6, pieData: supplierPieDataTemplate[4] },
      { name: '广水市诚信干货调料商行', value: 35.3, pieData: supplierPieDataTemplate[0] },
      { name: '广水市宏达水产批发部', value: 28.1, pieData: supplierPieDataTemplate[1] },
      { name: '广水市金源食用油经销部', value: 22.9, pieData: supplierPieDataTemplate[2] },
      { name: '广水市顺发蛋类批发中心', value: 18.7, pieData: supplierPieDataTemplate[3] },
      { name: '广水市优质冻品供应商', value: 12.4, pieData: supplierPieDataTemplate[4] },
    ],
    month: [
      { name: '广水市鑫源农产品有限公司', value: 18.6, pieData: supplierPieDataTemplate[0] },
      { name: '广水市绿色田园农业合作社', value: 15.8, pieData: supplierPieDataTemplate[1] },
      { name: '广水市永丰粮油批发部', value: 12.5, pieData: supplierPieDataTemplate[2] },
      { name: '广水市鲜达肉类经营部', value: 10.2, pieData: supplierPieDataTemplate[3] },
      { name: '广水市惠民蔬菜配送中心', value: 8.6, pieData: supplierPieDataTemplate[4] },
      { name: '广水市诚信干货调料商行', value: 6.3, pieData: supplierPieDataTemplate[0] },
      { name: '广水市宏达水产批发部', value: 5.1, pieData: supplierPieDataTemplate[1] },
      { name: '广水市金源食用油经销部', value: 4.9, pieData: supplierPieDataTemplate[2] },
      { name: '广水市顺发蛋类批发中心', value: 3.7, pieData: supplierPieDataTemplate[3] },
      { name: '广水市优质冻品供应商', value: 2.4, pieData: supplierPieDataTemplate[4] },
    ],
  }
  return Promise.resolve({
    code: 0,
    data: {
      list: dataMap[timeRange],
    },
    message: 'success',
  })
}

// 弹窗接口 - 1. 在售商品分页查询
export const getOnsaleProductList = (params = {}) => {
  const { current = 1, size = 18 } = params
  const total = 156
  const productNames = [
    '新鲜西红柿',
    '有机黄瓜',
    '优质大米',
    '土鸡蛋',
    '五花肉',
    '鲜活草鱼',
    '新鲜土豆',
    '胡萝卜',
    '大白菜',
    '青辣椒',
    '白萝卜',
    '洋葱',
    '生姜',
    '大蒜',
    '香菜',
    '芹菜',
    '菠菜',
    '油麦菜',
    '生菜',
    '西兰花',
    '花菜',
    '茄子',
    '豆角',
    '南瓜',
    '冬瓜',
    '丝瓜',
    '苦瓜',
    '莲藕',
    '山药',
    '红薯',
  ]

  const records = []
  const startIndex = (current - 1) * size
  for (let i = 0; i < size; i++) {
    const index = startIndex + i
    if (index >= total) break
    records.push({
      id: index + 1,
      materialName:
        productNames[index % productNames.length] +
        (Math.floor(index / productNames.length) > 0
          ? ` ${Math.floor(index / productNames.length) + 1}`
          : ''),
      imgName: null,
    })
  }

  return Promise.resolve({
    code: 0,
    data: {
      list: records,
      total,
      current,
      size,
    },
    message: 'success',
  })
}

// 弹窗接口 - 2. 采购学校分页查询
export const getSchoolList = (params = {}) => {
  const { current = 1, size = 11 } = params
  const total = 128
  const zbNames = [
    '吴店镇',
    '郝店镇',
    '杨寨镇',
    '广水街道',
    '马坪镇',
    '长岭镇',
    '陈巷镇',
    '骆店镇',
    '城郊街道',
  ]
  const zbCodes = ['wd', 'hd', 'yz', 'gs', 'mp', 'cl', 'cx', 'ld', 'cj']

  const records = []
  const startIndex = (current - 1) * size
  for (let i = 0; i < size; i++) {
    const index = startIndex + i
    if (index >= total) break
    const townIndex = index % zbNames.length
    records.push({
      customerId: `S${String(index + 1).padStart(6, '0')}`,
      schoolName: `广水市${zbNames[townIndex]}第${Math.floor(index / zbNames.length) + 1}小学`,
      zbCode: zbCodes[townIndex],
      zbName: zbNames[townIndex],
      purchaseAmount: (Math.random() * 200 + 50).toFixed(2),
      joinTime: `202${Math.floor(Math.random() * 4)}-${String(
        Math.floor(Math.random() * 12) + 1,
      ).padStart(2, '0')}-${String(Math.floor(Math.random() * 28) + 1).padStart(2, '0')} ${String(
        Math.floor(Math.random() * 24),
      ).padStart(2, '0')}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}:${String(
        Math.floor(Math.random() * 60),
      ).padStart(2, '0')}`,
    })
  }

  return Promise.resolve({
    code: 0,
    data: {
      list: records,
      total,
      current,
      size,
    },
    message: 'success',
  })
}

// 弹窗接口 - 3. 采购订单分页查询
export const getPurchaseOrderList = (params = {}) => {
  const { current = 1, size = 11 } = params
  const total = 6081
  const storeNames = ['万象', '俪丰', '联农']
  const materials = [
    '西红柿 * 5.00；黄瓜 * 3.00；土豆 * 10.00',
    '大米 * 50.00；食用油 * 5.00；鸡蛋 * 30.00',
    '五花肉 * 8.00；草鱼 * 6.00；白萝卜 * 15.00',
    '胡萝卜 * 10.00；大白菜 * 20.00；生姜 * 2.00',
    '洋葱 * 8.00；大蒜 * 3.00；香菜 * 1.00',
    '芹菜 * 5.00；菠菜 * 8.00；油麦菜 * 6.00',
    '西兰花 * 4.00；花菜 * 5.00；茄子 * 7.00',
    '豆角 * 6.00；南瓜 * 12.00；冬瓜 * 15.00',
  ]

  const records = []
  const startIndex = (current - 1) * size
  for (let i = 0; i < size; i++) {
    const index = startIndex + i
    if (index >= total) break
    const orderDate = new Date()
    orderDate.setDate(orderDate.getDate() - Math.floor(Math.random() * 30))
    const deliveryDate = new Date(orderDate)
    deliveryDate.setDate(deliveryDate.getDate() + 1)

    records.push({
      id: index + 1,
      orderNo: `TC${String(index + 1).padStart(6, '0')}`,
      gmOrderId: `GM${String(index + 1).padStart(6, '0')}`,
      gmOutOrderId: `OUT${String(index + 1).padStart(6, '0')}`,
      gmCustomerName: `广水市${['吴店镇', '郝店镇', '杨寨镇'][index % 3]}第${Math.floor(index / 3) +
        1}小学`,
      orderStatus: (index % 5) + 1,
      totalAmount: (Math.random() * 5000 + 1000).toFixed(2),
      orderTime: `${orderDate.getFullYear()}-${String(orderDate.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(orderDate.getDate()).padStart(2, '0')} ${String(
        Math.floor(Math.random() * 24),
      ).padStart(2, '0')}:${String(Math.floor(Math.random() * 60)).padStart(2, '0')}:${String(
        Math.floor(Math.random() * 60),
      ).padStart(2, '0')}`,
      scheduledTime: `${deliveryDate.getFullYear()}-${String(deliveryDate.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(deliveryDate.getDate()).padStart(2, '0')} 12:00:00`,
      actualTime: `${deliveryDate.getFullYear()}-${String(deliveryDate.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(deliveryDate.getDate()).padStart(2, '0')} 11:30:00`,
      expectedDeliveryTime: `${deliveryDate.getFullYear()}-${String(
        deliveryDate.getMonth() + 1,
      ).padStart(2, '0')}-${String(deliveryDate.getDate()).padStart(2, '0')} 12:00:00`,
      receiveTime: `${deliveryDate.getFullYear()}-${String(deliveryDate.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(deliveryDate.getDate()).padStart(2, '0')} 11:30:00`,
      contactUser: '张老师',
      contactPhone: '13800138000',
      deliveryAddress: `广水市${['吴店镇', '郝店镇', '杨寨镇'][index % 3]}第${Math.floor(
        index / 3,
      ) + 1}小学`,
      remark: '无',
      supplier: `供应商${String.fromCharCode(65 + (index % 5))}`,
      storeName: storeNames[index % storeNames.length],
      createSerialName: '系统导入',
      allocatePriceTotal: (Math.random() * 4500 + 900).toFixed(2),
      wxPutActualTotalPriceTotal: (Math.random() * 4800 + 950).toFixed(2),
      wxDeliveryTotalPriceTotal: (Math.random() * 5000 + 1000).toFixed(2),
      ckPutTotalPriceTotal: (Math.random() * 5000 + 1000).toFixed(2),
      materialNames: materials[index % materials.length]
        .replace(/ \* /g, ',')
        .split('；')
        .join(','),
      orderDetail: materials[index % materials.length],
      createTime: `${orderDate.getFullYear()}-${String(orderDate.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(orderDate.getDate()).padStart(2, '0')} 18:13:46`,
    })
  }

  return Promise.resolve({
    code: 0,
    data: {
      list: records,
      total,
      current,
      size,
    },
    message: 'success',
  })
}

// 默认导出所有接口
export default {
  getGroupStoreList,
  getStatsCards,
  getOrderLineChart,
  getAmountLineChart,
  getSaleTypePie,
  getSaleTypeBar,
  getProductSalesRank,
  getProductAmountRank,
  getPlatformTotal,
  getMapData,
  getMapTableData,
  getSchoolPurchaseRank,
  getWanxiangMonthlyStats,
  getSupplierSalesRank,
  getOnsaleProductList,
  getSchoolList,
  getPurchaseOrderList,
}
